import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import {
  Divider,
  NewSearchEmptyContainer,
  NewSearchEmptyLink,
  NewSearchEmptyText,
  NewSearchEmptyTitle
} from './styled';

interface NewSearchEmptyProps {
  onClickHandler: () => void;
  linkText?: string;
  emptyText?: string;
}

export const NewSearchEmpty = ({
  onClickHandler,
  linkText,
  emptyText
}: NewSearchEmptyProps) => {
  const { t } = useTranslation();

  return (
    <>
      {linkText && <Divider />}
      <NewSearchEmptyContainer>
        <Image
          width={317}
          height={270}
          src="/static/images/new_ad/icons/icon-not-found.png"
          data-cy="empty-icon"
          alt=""
        />

        {linkText && (
          <NewSearchEmptyTitle data-cy="empty-title">
            {t('search.nothing_found')}
          </NewSearchEmptyTitle>
        )}

        {linkText && (
          <NewSearchEmptyLink
            href="#"
            onClick={onClickHandler}
            data-cy="empty-link"
          >
            {linkText}
          </NewSearchEmptyLink>
        )}

        {emptyText && (
          <NewSearchEmptyText tag="body_1" data-cy="city_empty_text">
            {emptyText}
          </NewSearchEmptyText>
        )}
      </NewSearchEmptyContainer>
    </>
  );
};
